import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const languages = [
    { code: 'en', name: 'English', nativeName: 'English' },
    { code: 'zh', name: 'Chinese', nativeName: '中文' },
  ];

  const handleLanguageChange = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
  };

  return (
    <div className='relative group'>
      <button
        className='flex items-center space-x-2 px-3 py-2 text-sm font-display font-medium text-ui-sidebar-text bg-white/10 border border-white/20 rounded-ui-md hover:bg-white/20 hover:text-white transition-all duration-150'
        aria-expanded='false'
        aria-haspopup='listbox'
      >
        <svg
          className='w-4 h-4 mr-1 flex-shrink-0'
          fill='none'
          stroke='currentColor'
          viewBox='0 0 24 24'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129'
          />
        </svg>
        <span className='truncate'>
          {languages.find(lang => lang.code === i18n.language)?.nativeName || 'English'}
        </span>
        <svg
          className='w-4 h-4 ml-1 transition-transform group-hover:rotate-180 flex-shrink-0'
          fill='none'
          stroke='currentColor'
          viewBox='0 0 24 24'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M19 9l-7 7-7-7' />
        </svg>
      </button>

      <div className='absolute left-0 z-50 w-48 mt-2 origin-top-left bg-white border border-ui-border rounded-ui-md shadow-ui-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200'>
        <div className='py-1' role='menu'>
          {languages.map(language => (
            <button
              key={language.code}
              onClick={() => handleLanguageChange(language.code)}
              className={`w-full px-4 py-2 text-sm text-left hover:bg-ui-light flex items-center justify-between font-body ${
                i18n.language === language.code ? 'bg-ui-light text-ui-primary' : 'text-ui-charcoal'
              }`}
              role='menuitem'
            >
              <span className='font-display font-medium'>{language.nativeName}</span>
              <span className='text-xs text-ui-muted'>{language.name}</span>
              {i18n.language === language.code && (
                <svg
                  className='w-4 h-4 text-ui-primary flex-shrink-0'
                  fill='currentColor'
                  viewBox='0 0 20 20'
                >
                  <path
                    fillRule='evenodd'
                    d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                    clipRule='evenodd'
                  />
                </svg>
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LanguageSwitcher;
